import { render, staticRenderFns } from "./xeBizInfoSetting.vue?vue&type=template&id=4fb789c0"
import script from "./xeBizInfoSetting.vue?vue&type=script&lang=js"
export * from "./xeBizInfoSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports